// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios';
import advertisement from './components/advertisement'

const baseURL = "https://www.lljrtj.com"
axios.defaults.timeout = 10000;
axios.defaults.baseURL = baseURL
// 全局图片url
Vue.prototype.baseURL = baseURL
Vue.use(Vant);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


Vue.component("advertisement", advertisement)



// WEBPACK FOOTER //
// ./src/main.js